import { exists } from '@/api'

export interface BatchLendCollectionListCondition {
  lendDateFrom: string
  lendDateTo: string
  dueDateFrom: string
  dueDateTo: string
  userId: string
  userTypeCondition: string
  userType: string
  branchType: string
  branchCode: string
  newLineCondition: string
}

export function BatchLendCollectionListConditionFromJSON(
  json: any
): BatchLendCollectionListCondition {
  const _json = JSON.parse(json)

  return {
    lendDateFrom: exists(_json, 'lend_date_from') ? _json.lend_date_from : '',
    lendDateTo: exists(_json, 'lend_date_to') ? _json.lend_date_to : '',
    dueDateFrom: exists(_json, 'due_date_from') ? _json.due_date_from : '',
    dueDateTo: exists(_json, 'due_date_to') ? _json.due_date_to : '',
    userId: exists(_json, 'user_id') ? _json.user_id : '',
    userTypeCondition: exists(_json, 'user_type_condition')
      ? _json.user_type_condition
      : '1',
    userType: exists(_json, 'user_type') ? _json.user_type : '',
    branchType: exists(_json, 'branch_type') ? _json.branch_type : '1',
    branchCode: exists(_json, 'branch_code') ? _json.branch_code : '',
    newLineCondition: exists(_json, 'new_line_condition')
      ? _json.new_line_condition
      : '1'
  }
}
